import './BIDashboard.scss'

import React, { cloneElement, useEffect, useState } from "react"

import {
    CheckCircleTwoTone,
    WarningTwoTone,
    CloseCircleTwoTone,
    InfoCircleOutlined,
    FileExcelOutlined
} from '@ant-design/icons'
import { Button, Checkbox, Col, Collapse, Form, Row, Select, Tooltip } from "antd"
import { useApi } from '../../Utils'
import { useWatch } from 'antd/lib/form/Form'

type IndicatorType = 'ok' | 'warn' | 'error'

function IndicatorStatus({
    type,
    textMap,
    tooltip
}: {
    type: IndicatorType,
    textMap: readonly [IndicatorType, string][],
    tooltip: JSX.Element
}) {
    const icon = new Map<IndicatorType, JSX.Element>([
        ['ok', <CheckCircleTwoTone size={32} twoToneColor="#52c41a" />],
        ['warn', <WarningTwoTone size={32} twoToneColor="#ffcc00" />],
        ['error', <CloseCircleTwoTone size={32} twoToneColor="#eb2f96" />],
    ])

    const text = new Map<IndicatorType, string>(textMap)

    return <div className="IndicatorStatus" style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }}>
            {cloneElement(icon.get(type), {
                style: {
                    fontSize: '18px'
                }
            })}
            {text.get(type)}
            &nbsp;
            <Tooltip title={tooltip}>
                &nbsp;
                <InfoCircleOutlined />
            </Tooltip>
        </div>
}

type RetailEntity = {
    id_retail: number
    nombre: string
    logo?: string
    fecha?: string
    sucursales?: SucursalEntity[]
}

type SucursalEntity = {
    id_sucursal: number
    id_retail: number
    nombre_sucursal: string
    codigo_local: string
    formato?: string
    keyTienda: string
}

type ProcesoEntity = {
    id: number
    yearMonth: number
    name: string
    enabled: number
}

type MarcaEntity = {
    brandName: string
}

export default function BIDashboard({ setMainLoading }: any) {
    const { data, loading } = useApi<any>('get', 'v3/clso/dashboard', {
        onRequest: false,
        requiredToken: true
    })

    const [form] = Form.useForm();

    const [indicatorStatusType, setIndicatorStatusType] = useState<IndicatorType>('warn')
    const [indicatorLastVenta, setIndicatorLastVenta] = useState<RetailEntity[]>([])
    const [procesos, setProcesos] = useState<ProcesoEntity[]>([])
    const [marcas, setMarcas] = useState<MarcaEntity[]>([])
    const [retails, setRetails] = useState<RetailEntity[]>([]) 
    const [sucursales, setSucursales] = useState<SucursalEntity[]>([])

    const retailers = useWatch('retailers', form)

    useEffect(() => {
        setMainLoading(loading)
    }, [loading, setMainLoading])

    useEffect(() => {
        console.log({data})
        if (data?.status === 'success') {
            setIndicatorLastVenta(data.lastVenta)
            setIndicatorStatusType(data.indicatorStatus)
            setProcesos(data.procesos)
            setMarcas(data.marcas.filter((m: MarcaEntity) => m.brandName !== ""))
            setRetails(data.retailSucursal)
            // Obtener todas las sucursales
            const _sucs = data.retailSucursal.reduce((acc: SucursalEntity[], r: RetailEntity) => {
                return acc.concat(r.sucursales!)
            }, [] as SucursalEntity[])
            setSucursales(_sucs)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        const _sucs = (retailers?.length
            ? retails.filter(r => retailers.includes(r.id_retail))
            : retails
        ).reduce((acc: SucursalEntity[], r: RetailEntity) => {
            return acc.concat(r.sucursales!);
        }, []);

        setSucursales(_sucs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [retailers]);

    // useEffect(() => {
    //     const values = form.getFieldsValue();
    //     const retailers = values.retailers as number[]
        
    //     if (retailers.length) {
    //         const _sucs = retails.filter(r => retailers.includes(r.id_retail)).reduce((acc: SucursalEntity[], r: RetailEntity) => {
    //             return acc.concat(r.sucursales!)
    //         }, [] as SucursalEntity[])
    //         setSucursales(_sucs)
    //     } else {
    //         const _sucs = retails.reduce((acc: SucursalEntity[], r: RetailEntity) => {
    //             return acc.concat(r.sucursales!)
    //         }, [] as SucursalEntity[])
    //         setSucursales(_sucs)
    //     }


    //     console.log('Valores actuales:', values);
    // }, [form.getFieldsValue()]);

    const RetailItem = ({ retail }: { retail: RetailEntity}) => {
        return <div className="item" style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }}>
            <img alt={retail.logo} src={retail.logo} width={16} />
            <strong style={{ flex: 1 }}>{retail.nombre}:</strong>
            <span>{retail.fecha!.substring(0, 10)}</span>
        </div>
    }

    return <div className="BIDashboard">

        <div className="BIDashboard__Toolbar">
            <Button type="text">
                <FileExcelOutlined />
                Exportar a Excel
            </Button>
            
            <IndicatorStatus
                type={indicatorStatusType}
                textMap={[
                    ['ok', "Sincronización correcta"],
                    ['warn', "Sicronización en proceso"],
                    ['error', "Error de sincronización"],
                ]}
                tooltip={<div className="items" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                }}>
                    {indicatorLastVenta.map((retailer) => <RetailItem retail={retailer} />)}
                </div>}
                />
        </div>
        <div className="BIDashboard__Main">
            <div className="BIDashboard__Main__Report">
                {/* <Result
                    status="success"
                    title="Successfully Purchased Cloud Server ECS!"
                    subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
                    extra={[
                        <Button type="primary" key="console">
                            Go Console
                        </Button>,
                        <Button key="buy">Buy Again</Button>,
                    ]}
                /> */}
            </div>
            <div className="BIDashboard__Main__Filters">
                <Form
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    layout="vertical"
                    form={form}
                    // onValuesChange={onFormLayoutChange}
                    // disabled={componentDisabled}
                >
                    <Collapse defaultActiveKey={['1', '2']}>
                        <Collapse.Panel header="Filtros comunes" key="1">
                            {/* <Form.Item label="Periodo">
                                <DatePicker.RangePicker />
                            </Form.Item> */}
                            <Form.Item name="period" label="Periodo(s)" required>
                                <Select mode="multiple" placeholder="Selecciona un periodo">
                                    {procesos.map(proceso => <Select.Option value={proceso.yearMonth}>{proceso.name}</Select.Option>)}
                                </Select>
                            </Form.Item>
                            <Form.Item name="brands" label="Marca(s)">
                                <Select mode="multiple" placeholder="Todas">
                                    {marcas.map(({ brandName }) => <Select.Option value={brandName}>{brandName}</Select.Option>)}
                                </Select>
                            </Form.Item>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item name="retailers" label="Retail">
                                        <Select mode="multiple" placeholder="Todos">
                                            {retails.map((r) => <Select.Option value={r.id_retail}>{r.nombre}</Select.Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="stores" label="Tienda">
                                        <Select placeholder="Todas" mode="multiple">
                                            {sucursales.map((s) => <Select.Option value={s.keyTienda}>{s.nombre_sucursal}</Select.Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            {/* <Form.Item label="Incluir comparativa año anterior" valuePropName="checked">
                                <Switch />
                            </Form.Item> */}
                        </Collapse.Panel>
                        <Collapse.Panel header="Trade: Cumplimiento" key="2">
                            <Form.Item name="LY" valuePropName="checked">
                                <Checkbox>Incluir mismo periodo año anterior</Checkbox>
                            </Form.Item>
                            <Form.Item name="grouped" valuePropName="checked">
                                <Checkbox>Agrupar por Marcas</Checkbox>
                            </Form.Item>
                            <Form.Item name="compliance" valuePropName="checked">
                                <Checkbox>Incluir cumplimiento de metas</Checkbox>
                            </Form.Item>
                            <Form.Item name="percentPT" label="Porcentaje Partime">
                                <Select>
                                    {[
                                        30,
                                        35,
                                        40,
                                        45,
                                        50,
                                        55,
                                        60,
                                        65,
                                        70,
                                        75
                                    ].map((percent) => <Select.Option value={percent}>{percent}%</Select.Option>)}
                                </Select>
                            </Form.Item>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item name="" label="Días del Mes">
                                        <Select mode="multiple" placeholder="Todos">
                                            {new Array(31).fill(1).map((_s, i) => <Select.Option value={i + 1}>{i + 1}</Select.Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Días de la Semana">
                                        <Select mode="multiple" placeholder="Todos">
                                            {[
                                                'Lunes',
                                                'Martes',
                                                'Miercoles',
                                                'Jueves',
                                                'Viernes',
                                                'Sabado',
                                                'Domingo'
                                            ].map((day) => <Select.Option value={day}>{day}</Select.Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Collapse.Panel>
                    </Collapse>
                </Form>
            </div>
        </div>
    </div>
}